import React from "react";
import { Text, Spacer, Image, TextInline } from "../dynamic.components";
import screen from "src/assets/images/unicorn/screen.png";
import graph from "src/assets/images/unicorn/graph.png";
import graph2 from "src/assets/images/unicorn/graph2.png";
import SubHotspots from "../Sub-hotspots";

export const UnicornSubhotspot: React.FC = () => (
  <>
    <Spacer />
    <Text text="The software includes four modules:" />
    <Spacer />
  </>
);
export const MethodEditor: React.FC = () => (
  <>
    <Spacer x={1} />
    <TextInline fontStyle="italic" weight="bold" text="• Method Editor: " />
    <TextInline text="provides an easy interface to create or modify methods." />
    <Spacer x={1} />
  </>
);
export const SystemControl: React.FC = () => (
  <>
    <Spacer />
    <TextInline fontStyle="italic" weight="bold" text="• System Control: " />
    <TextInline text="allows performing and monitoring the run in real time." />

    <Spacer />
  </>
);
export const Evaluation: React.FC = () => (
  <>
    <Spacer />
    <TextInline fontStyle="italic" weight="bold" text="• Evaluation: " />
    <TextInline text="supports data analysis and report generation." />

    <Spacer />
  </>
);
export const Administration: React.FC = () => (
  <>
    <Spacer />
    <TextInline fontStyle="italic" weight="bold" text="• Administration: " />
    <TextInline text="used to set up user access, which allows different levels of system access for user types, and for other administrative actions." />

    <Spacer />
  </>
);

export const Unicorn: React.FC = () => {
  return (
    <>
      <div className="c-sidebar__body">
        <Text text="UNICORN™ system control software is based on an integrated controller and an intuitive user interface." />
        <Text text="The UNICORN™ software contains the tools needed to perform almost any type of crossflow filtration process at different scales, from setting up and running a method to evaluating the data." />
        <Spacer x={2} />

        <SubHotspots sublinkId="3-1" />

        {/* <Image
          images={[
            {
              src: screen,
              alt: "Screen image",
              customWidth: "80%",
            },
            {
              src: graph,
              alt: "Graph image",
              customWidth: "80%",
            },
            {
              src: graph2,
              alt: "Graph2 image",
              customWidth: "80%",
            },
          ]}
        /> */}
      </div>
    </>
  );
};
